// extracted by mini-css-extract-plugin
module.exports = {"tagBody":"Tag-module_tagBody_3Vvf9"};